import { css, cx } from 'emotion';

import SubmittedBG from 'inside-out/images/submitted-bg.svg';

import {
	grey,
	headingSmall,
	headingXLarge,
	mobileMaxWidthBreakpoint,
	desktopMaxWidthBreakpoint,
	textBlock,
	metaTable,
} from 'inside-out/global-styles';

export const innerStyleOrganisation = css({
	'& img': {
		display: 'block',
		maxWidth: '255px',
	},
});

export const titleStyle = cx(
	headingXLarge,
	css({
		margin: '0 0 8px 0',
	})
);

export const subTitleStyle = cx(
	headingSmall,
	css({
		margin: '0 0 13px 0',
	})
);

export const locationStyle = css({
	color: grey,
	fontWeight: 300,
	fontSize: '22px',
	lineHeight: '26px',
	marginTop: 0,
	marginBottom: '36px',
});

export const wrapperStyle = hasBG =>
	css({
		...(hasBG
			? {
					background: `transparent url(${SubmittedBG}) no-repeat bottom right`,
			  }
			: null),
	});

export const innerWrapperStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	height: '100%',
	margin: '0 auto',
	position: 'relative',
});

export const bodyStyle = cx(
	textBlock,
	css({
		marginBottom: '60px',
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			fontSize: '14px',
		},
	})
);

export const metaStyle = cx(
	metaTable,
	css({
		marginBottom: '40px',
	})
);

export const messageTextareaStyle = css({
	height: '150px',
});



// WEBPACK FOOTER //
// ./src/page-styles/employment/detail/index.js